module.exports = __webpack_public_path__ + "img/polar@2x.f1a6a3a.jpg";